export var MPXStatus;
(function (MPXStatus) {
    MPXStatus["AVAILABLE"] = "AVAILABLE";
    MPXStatus["DELAYED"] = "DELAYED";
    MPXStatus["EXPIRED"] = "EXPIRED";
    MPXStatus["PREMIUM"] = "PREMIUM";
    MPXStatus["PREMIUM_EST"] = "PREMIUM_EST";
})(MPXStatus || (MPXStatus = {}));
